import { render } from "./video_pop_up.vue?vue&type=template&id=10ad7658"
import script from "./video_pop_up.vue?vue&type=script&lang=js"
export * from "./video_pop_up.vue?vue&type=script&lang=js"

import "./video_pop_up.vue?vue&type=style&index=0&id=10ad7658&lang=scss"

import exportComponent from "/home/forge/binalogue.stage-preview.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__